var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Panel de Mujeres")]),_c('div',[_c('formulario-addmujer')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }